export enum LinkShareTypes {
  Email = 'email',
  Facebook = 'facebook',
  WhatsApp = 'whatsapp',
  IMessage = 'iMessage'
}
